type ErrorWithHttpStatus = {
  data?: {
    httpStatus?: unknown;
  };
};

type UserContextRecovery = "onboarding" | "sign-out";

export function getUserContextRecovery(error: unknown): UserContextRecovery | null {
  if (!error || typeof error !== "object") {
    return null;
  }

  const httpStatus = (error as ErrorWithHttpStatus).data?.httpStatus;

  if (httpStatus === 401) {
    return "sign-out";
  }

  if (httpStatus === 404) {
    return "onboarding";
  }

  return null;
}
